const formatICSDate = (date) => {
  return date.toISOString().replace(/[-:]/g, '').split('.')[0] + 'Z';
};

const generateICSContent = (event) => {
  const startDate = new Date(event.StartDateTime);
  const endDate = new Date(event.EndDateTime);
  
  return `BEGIN:VCALENDAR
VERSION:2.0
PRODID:-//DriftCal//EN
CALSCALE:GREGORIAN
BEGIN:VEVENT
DTSTART:${formatICSDate(startDate)}
DTEND:${formatICSDate(endDate)}
SUMMARY:${event.EventName}
DESCRIPTION:Event Type: ${event.EventType}\\nVenue: ${event.VenueName}\\nLayout: ${event.LayoutName}\\nTimezone: GMT${event.GMT}
LOCATION:${event.GoogleMapsLink || `${event.VenueName}, ${event.City}, ${event.StateNameShort}`}
END:VEVENT
END:VCALENDAR`;
};

const generateGoogleCalendarUrl = (event) => {
  const startDate = new Date(event.StartDateTime);
  const endDate = new Date(event.EndDateTime);
  const formattedStart = formatICSDate(startDate);
  const formattedEnd = formatICSDate(endDate);

  const googleUrl = new URL('https://calendar.google.com/calendar/render');
  googleUrl.searchParams.append('action', 'TEMPLATE');
  googleUrl.searchParams.append('text', event.EventName);
  googleUrl.searchParams.append('dates', `${formattedStart}/${formattedEnd}`);
  googleUrl.searchParams.append('details', `Event Type: ${event.EventType}\nVenue: ${event.VenueName}\nLayout: ${event.LayoutName}\nTimezone: GMT${event.GMT}`);
  googleUrl.searchParams.append('location', event.GoogleMapsLink || `${event.VenueName}, ${event.City}, ${event.StateNameShort}`);
  
  return googleUrl.toString();
};

export const openCalendarInvite = (event) => {
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  if (isMobile) {
    // Create and download ICS file for mobile
    const icsContent = generateICSContent(event);
    const blob = new Blob([icsContent], { type: 'text/calendar;charset=utf-8' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${event.EventName.replace(/[^a-z0-9]/gi, '_')}.ics`);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } else {
    // Open Google Calendar for desktop
    const calendarUrl = generateGoogleCalendarUrl(event);
    window.open(calendarUrl, '_blank', 'noopener,noreferrer');
  }
};
